import produce from 'immer';

import { Action } from '../../actions';
import { UPDATE_USER_SETTINGS_DATA } from '../../actions/userSettings';
import { PageStatus } from '../../typings/common';
import { State, UserSettingsState } from '../../typings/state';

const userSettingsInitialState = {
    reqId: undefined,
    pageStatus: PageStatus.LOADING,
    measurerAccounts: []
};

export function userSettings(
    state: UserSettingsState = userSettingsInitialState,
    action: Action,
    fullState: State
): UserSettingsState {
    switch (action.type) {
        case UPDATE_USER_SETTINGS_DATA:
            return produce(state, draftState => {
                draftState.pageStatus = PageStatus.LOADED;
                draftState.measurerAccounts = action.measurerAccounts;
            });
        default:
            return state;
    }
}
